import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemeListesiv2EvrakDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemeListesiv2EvrakDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  YuklemePlan_Get_TeslimEvrakListe: any[];
  YuklemePlan_Get_TeslimEvrakListe_dummy: any[];
  YuklemePlan_Get_EvrakOnayDetails: any[];
  YuklemePlan_Get_EvrakOnayDetails_dummy: any[];
  PhotosFromGallery: any[];
  PhotosFromGallery_dummy: any[];
  YuklemePlan_Save_TeslimEvrak: any[];
  YuklemePlan_Save_TeslimEvrak_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  DownloadFile: any;
  DownloadFile_dummy: any;
  YuklemePlan_EvrakSil: number;
  YuklemePlan_EvrakSil_dummy: number;
  YuklemePlan_EvrakOnay: number;
  YuklemePlan_EvrakOnay_dummy: number;
  Sms_Send: string;
  Sms_Send_dummy: string;
  GetMailBody_TedarikciEvrakRedBildirim: string;
  GetMailBody_TedarikciEvrakRedBildirim_dummy: string;
  SendMail: boolean;
  SendMail_dummy: boolean;
  YuklemePlan_RefreshSmsCode: number;
  YuklemePlan_RefreshSmsCode_dummy: number;
  GetTextForSMSRefresh: any[];
  GetTextForSMSRefresh_dummy: any[];
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GoBack: any;
  GoBack_dummy: any;
  isComp937970Visible: "visible" | "hidden";
}

export class YuklemeListesiv2EvrakDetay_ScreenBase extends React.PureComponent<
  IYuklemeListesiv2EvrakDetay_ScreenProps,
  any
> {
  yuklemelistesiv2evrakdetay_485635_value_kuikaCarouselRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "98a5fed1-e7bd-4619-96bb-b736a3a60ec5",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 409199,
          PropertyName: "value",
          Value: "Teslimat Evrak Kontrol Ekranı",
        },
        { Id: 433345, PropertyName: "value", Value: "Yükleme No" },
        { Id: 352785, PropertyName: "value", Value: "Teslimat No" },
        { Id: 160497, PropertyName: "value", Value: "Müşteri" },
        { Id: 205964, PropertyName: "value", Value: "Teslim Yeri" },
        { Id: 235229, PropertyName: "value", Value: "Teslim Tarihi" },
        { Id: 358423, PropertyName: "value", Value: "İade Var Mı" },
        { Id: 866602, PropertyName: "value", Value: "Hasarlı İade Var Mı ?" },
        { Id: 337070, PropertyName: "value", Value: "Hasarlı İade Miktar" },
        { Id: 923402, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 318840, PropertyName: "value", Value: "Eksik Fazla Var Mı ?" },
        { Id: 451568, PropertyName: "value", Value: "Eksik - Fazla Miktar" },
        { Id: 920150, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 367880, PropertyName: "value", Value: "Teslimat" },
        { Id: 479436, PropertyName: "placeholder", Value: "Type here..." },
        {
          Id: 485635,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 86143, PropertyName: "label", Value: "Evrak Yükle" },
        { Id: 1301, PropertyName: "label", Value: "Evrak İndir" },
        { Id: 466722, PropertyName: "label", Value: "Evrak Sil" },
        {
          Id: 937970,
          PropertyName: "placeholder",
          Value: "Evrak iade nedeni yazınız...",
        },
        { Id: 476254, PropertyName: "value", Value: "İrsaliye No" },
        { Id: 452233, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 871507, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemelistesiv2evrakdetay_923402_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetay_920150_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetay_479436_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetay_485635_value_kuikaCarouselRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetay_937970_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemelistesiv2evrakdetay_452233_value_kuikaTextInputRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      YuklemePlan_Get_TeslimEvrakListe: [],
      YuklemePlan_Get_EvrakOnayDetails: [],
      PhotosFromGallery: [],
      YuklemePlan_Save_TeslimEvrak: [],
      Notify: false,
      DownloadFile: "",
      YuklemePlan_EvrakSil: 0,
      YuklemePlan_EvrakOnay: 0,
      IfThenElse: false,
      GoBack: "",
      dataSource_134872: [
        { key: "O", text: "ONAYLA" },
        { key: "R", text: "REDDET" },
      ],
      isComp937970Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "yuklemelistesiv2evrakdetay",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemeListesiv2EvrakDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemelistesiv2evrakdetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["SuperUser"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemelistesiv2evrakdetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemeListesiv2EvrakDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemelistesiv2evrakdetay_153582_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.iadeVar ??
        undefined,
      yuklemelistesiv2evrakdetay_979979_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.hasarIade ??
        undefined,
      yuklemelistesiv2evrakdetay_923402_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.hasarliMiktar ??
        undefined,
      yuklemelistesiv2evrakdetay_574378_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.eksikFazla ??
        undefined,
      yuklemelistesiv2evrakdetay_920150_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)
          ?.eksikFazlaMiktar ?? undefined,
      yuklemelistesiv2evrakdetay_479436_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.aciklama ??
        undefined,
      yuklemelistesiv2evrakdetay_134872_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.teslimEvrakOnay ??
        undefined,
      yuklemelistesiv2evrakdetay_937970_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)
          ?.teslimEvrakRedNeden ?? undefined,
      yuklemelistesiv2evrakdetay_452233_value:
        this.state.YuklemePlan_Get_EvrakOnayDetails?.at?.(0)?.irsaliyeNo ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemeListesiv2EvrakDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2EvrakDetayPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
      FirmaNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetay/YuklemeListesiv2EvrakDetayPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.YuklemePlan_Get_TeslimEvrakListe =
      result?.data.yuklemePlan_Get_TeslimEvrakListe;

    stateVars.YuklemePlan_Get_EvrakOnayDetails =
      result?.data.yuklemePlan_Get_EvrakOnayDetails;
    formVars.yuklemelistesiv2evrakdetay_21608_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_544116_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_670925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_458207_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_860922_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_153582_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_979979_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_923402_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_574378_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_920150_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_479436_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_937970_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimEvrakRedNeden
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimEvrakRedNeden
          : null
      );
    formVars.yuklemelistesiv2evrakdetay_452233_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2EvrakDetayPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemelistesiv2evrakdetay_21608_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_544116_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimatNo
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_670925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].musteriAdi
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_458207_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].varisNoktaAdi
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_860922_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimTarihi
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_153582_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].iadeVar
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_979979_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarIade
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_923402_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].hasarliMiktar
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_574378_value =
      ReactSystemFunctions.value(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazla
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_920150_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].eksikFazlaMiktar
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_479436_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].aciklama
          : null
      );

    stateVars.dataSource_485635 =
      stateVars.YuklemePlan_Get_TeslimEvrakListe ??
      this.state.YuklemePlan_Get_TeslimEvrakListe;
    formVars.yuklemelistesiv2evrakdetay_134872_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimEvrakOnay
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimEvrakOnay
          : null
      );

    formVars.yuklemelistesiv2evrakdetay_937970_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].teslimEvrakRedNeden
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].teslimEvrakRedNeden
          : null
      );

    stateVars.isComp937970Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_134872_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("R", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.yuklemelistesiv2evrakdetay_452233_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
          ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
            : null
          : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
          ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].irsaliyeNo
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayComponent_86143_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.PhotosFromGallery = (
      (await ReactSystemFunctions.getPhotosFromGallery(
        false,
        ReactSystemFunctions.convertToTypeByName("high", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayComponent_86143_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayComponent_86143_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
      DocumentData_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].dataBase64
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].dataBase64
            : null
        ),
        "string"
      ),
      DocumentName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.PhotosFromGallery !== undefined
            ? stateVars.PhotosFromGallery?.length > 0
              ? stateVars.PhotosFromGallery[0].name
              : null
            : this.state.PhotosFromGallery?.length > 0
            ? this.state.PhotosFromGallery[0].name
            : null
        ),
        "string"
      ),
      YuklemeTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("KONTROL EKRAN", "string"),
        "string"
      ),
      SmsResent_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetay/YuklemeListesiv2EvrakDetayComponent_86143_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Save_TeslimEvrak =
      result?.data.yuklemePlan_Save_TeslimEvrak;
    stateVars.YuklemePlan_Get_TeslimEvrakListe =
      result?.data.yuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayComponent_86143_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayComponent_86143_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f448f21f_2bd3_df07_2f02_58e240fc3262_notify",
        this.defaultML,
        "EVRAK YÜKLENDİ"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_485635 =
      stateVars.YuklemePlan_Get_TeslimEvrakListe ??
      this.state.YuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayComponent_1301_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.value(
        this,
        "yuklemelistesiv2evrakdetay_485635_value",
        ".documentData"
      ),
      ReactSystemFunctions.convertToTypeByName("TeslimEvrak", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayComponent_466722_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2evrakdetay_485635_value",
          ".id"
        ),
        "Guid"
      ),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ebe876e4_7d9e_e02c_0c22_ecbab0c3c1c2_confirmation",
        this.defaultML,
        "Ekranda gösterilen evrak bilgisi silinecek. Emin misiniz ?"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemeListesiv2EvrakDetay/YuklemeListesiv2EvrakDetayComponent_466722_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YuklemePlan_EvrakSil = result?.data.yuklemePlan_EvrakSil;
      stateVars.YuklemePlan_Get_TeslimEvrakListe =
        result?.data.yuklemePlan_Get_TeslimEvrakListe;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2EvrakDetayComponent_466722_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayComponent_466722_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_485635 =
      stateVars.YuklemePlan_Get_TeslimEvrakListe ??
      this.state.YuklemePlan_Get_TeslimEvrakListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayComponent_871507_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2evrakdetay_937970_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Red verilen belgede red nedeni zorunludur !",
      formName: "yuklemelistesiv2evrakdetay_937970_value",
      condition: ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_134872_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("R", "string")
      ),
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Onay_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_134872_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      RedNeden_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_937970_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      IrsaliyeNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_452233_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_479436_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EksikFazlaVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_574378_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      EksikFazlaMiktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_920150_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      HasarIadeVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_979979_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      HasarliMiktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_923402_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      IadeVar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_153582_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetay/YuklemeListesiv2EvrakDetayComponent_871507_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_EvrakOnay = result?.data.yuklemePlan_EvrakOnay;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2EvrakDetayComponent_871507_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2EvrakDetayComponent_871507_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      _Username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsUserName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsUserName
            : null
        ),
        "string"
      ),
      _Password_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsPassword
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsPassword
            : null
        ),
        "string"
      ),
      number_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
              ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].surucuGSM
              : null
            : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].surucuGSM
            : null
        ),
        "string"
      ),
      title_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "TESLIMAT EVRAK ONAY",
          "string"
        ),
        "string"
      ),
      content_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Teslimat Evraklarınız Onaylanmıştır.",
          "string"
        ),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsSenderName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsSenderName
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetay/YuklemeListesiv2EvrakDetayComponent_871507_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Sms_Send = result?.data.sms_Send;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayComponent_871507_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2evrakdetay_937970_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Red verilen belgede red nedeni zorunludur !",
      formName: "yuklemelistesiv2evrakdetay_937970_value",
      condition: ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_134872_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("R", "string")
      ),
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
              ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].yuklemeNo
            : null
        ),
        "string"
      ),
      TeslimatNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      RedNedeni_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_937970_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      templateId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
              ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].tasiyiciEPosta
              : null
            : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].tasiyiciEPosta
            : null
        ),
        "string"
      ),
      subject_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Reddedilen Teslimat Evrakları",
          "string"
        ),
        "string"
      ),
      sender_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_TedarikciEvrakRedBildirim
        ),
        "string"
      ),
      UserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
      YuklemeId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TeslimatNo_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeslimatNo ??
          this.props.screenInputs.teslimatno,
        "number"
      ),
      _Username_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsUserName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsUserName
            : null
        ),
        "string"
      ),
      _Password_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsPassword
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsPassword
            : null
        ),
        "string"
      ),
      number_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_EvrakOnayDetails !== undefined
            ? stateVars.YuklemePlan_Get_EvrakOnayDetails?.length > 0
              ? stateVars.YuklemePlan_Get_EvrakOnayDetails[0].surucuGSM
              : null
            : this.state.YuklemePlan_Get_EvrakOnayDetails?.length > 0
            ? this.state.YuklemePlan_Get_EvrakOnayDetails[0].surucuGSM
            : null
        ),
        "string"
      ),
      title_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "TESLIMAT EVRAK RED BİLDİRİMİ",
          "string"
        ),
        "string"
      ),
      content_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTextForSMSRefresh !== undefined
            ? stateVars.GetTextForSMSRefresh?.length > 0
              ? stateVars.GetTextForSMSRefresh[0].smsText
              : null
            : this.state.GetTextForSMSRefresh?.length > 0
            ? this.state.GetTextForSMSRefresh[0].smsText
            : null
        ),
        "string"
      ),
      sender_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].smsSenderName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].smsSenderName
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2EvrakDetay/YuklemeListesiv2EvrakDetayComponent_871507_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMailBody_TedarikciEvrakRedBildirim =
      result?.data.getMailBody_TedarikciEvrakRedBildirim;
    stateVars.SendMail = result?.data.sendMail;
    stateVars.YuklemePlan_RefreshSmsCode =
      result?.data.yuklemePlan_RefreshSmsCode;
    stateVars.GetTextForSMSRefresh = result?.data.getTextForSMSRefresh;
    stateVars.Sms_Send = result?.data.sms_Send;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayComponent_871507_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_134872_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "O"
      )
    ) {
      isErrorOccurred =
        await this.YuklemeListesiv2EvrakDetayComponent_871507_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.YuklemeListesiv2EvrakDetayComponent_871507_onClick_else1();
      if (isErrorOccurred) return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2EvrakDetayComponent_134872_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp937970Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2evrakdetay_134872_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "R"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemeListesiv2EvrakDetayPageInit();
    }
  }
}
